import { ShieldCheck } from "lucide-react";

/**
 * "RBI-authorised and fully compliant" trust badge.
 * Rendered centered below the header nav on every page.
 * Styling matches the existing pill/chip treatment used elsewhere (Account: active, See your savings — live).
 */
export default function RbiBadge({ className = "" }) {
  return (
    <div className={`w-full flex justify-center ${className}`} data-testid="rbi-badge">
      <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider border border-primary/20 text-primary bg-primary/5">
        <ShieldCheck className="h-3.5 w-3.5" />
        RBI-authorised and fully compliant
      </span>
    </div>
  );
}
